import React, { useState } from 'react';
import TeacherEnrollment from '../Teacher/TeacherEnrollment.jsx';
import NonTeachingStaffRegistration from './NonTeachingStaffRegistration.jsx';
import colors from '../Constant/colors.js';

const StaffEnrollment = () => {
  const [selectedForm, setSelectedForm] = useState('teacher');

  const activeBtn = {
    background: colors.gradientPrimary,
    color: "white",
  };

  const inactiveBtn = {
    background: "#f9fafb", // Tailwind gray-50
    color: "black",
  };

  return (
    <div className="p-6 bg-white shadow-lg rounded-lg border border-gray-200">
      
      {/* TAB BUTTONS */}
      <div className="mb-8 flex justify-center space-x-4">
        
        {/* Teacher Register TAB */}
        <button
          className="px-5 py-2.5 text-lg font-medium rounded-lg transition-all duration-500 ease-in-out transform"
          style={selectedForm === 'teacher' ? activeBtn : inactiveBtn}
          onClick={() => setSelectedForm('teacher')}
        >
          Teacher Register
        </button>

        {/* Non-Teaching TAB */}
        <button
          className="px-5 py-2.5 text-lg font-medium rounded-lg transition-all duration-500 ease-in-out transform"
          style={selectedForm === 'nonTeaching' ? activeBtn : inactiveBtn}
          onClick={() => setSelectedForm('nonTeaching')}
        >
          Non-Teaching Staff
        </button>

      </div>

      {/* FORMS */}
      {selectedForm === 'teacher' && <TeacherEnrollment />}
      {selectedForm === 'nonTeaching' && <NonTeachingStaffRegistration />}

    </div>
  );
};

export default StaffEnrollment;
